import React from "react";

const sk = (extra = {}) => ({
  backgroundColor: "#f0f0f0",
  borderRadius: "4px",
  animation: "skeleton-pulse 1.5s ease-in-out infinite",
  ...extra,
});

const HotelFilterSkeleton = () => {
  return (
    <div style={{ padding: "4px 2px" }}>
      {[0, 1, 2, 3].map((g) => (
        <div key={g} style={{ marginBottom: 28 }}>
          <div style={sk({ width: "55%", height: 16, marginBottom: 16 })} />
          {[0, 1, 2, 3].map((r) => (
            <div key={r} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
              <div style={sk({ width: 18, height: 18, flex: "none" })} />
              <div style={sk({ width: `${55 + r * 8}%`, height: 12 })} />
              <div style={sk({ width: 28, height: 12, marginLeft: "auto", flex: "none" })} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default HotelFilterSkeleton;
